import React from 'react';
import { Link, useLocation, Outlet } from 'react-router-dom';
import { usePortalAuth } from '../context/PortalAuthContext';
import { useTheme } from '../../context/ThemeContext';
import '../styles/portal.css';

export const PortalLayout: React.FC = () => {
  const { admin, stage, logout } = usePortalAuth();
  const { theme, toggleTheme } = useTheme();
  const location = useLocation();
  const isAuthenticated = stage === 'fully_authenticated';

  const navItems = isAuthenticated
    ? [
        { to: '/ip-portal/dashboard', label: 'Dashboard' },
        { to: '/ip-portal/devices', label: 'Devices' },
        { to: '/ip-portal/audit', label: 'Audit Log' },
        ...(admin?.role === 'super_admin'
          ? [{ to: '/ip-portal/invite', label: 'Invite Admin' }]
          : []),
      ]
    : [];

  return (
    <div className="portal-root">
      <header className="portal-header">
        <div className="portal-header-inner">
          <Link to="/ip-portal/dashboard" className="portal-logo">
            IP Whitelist Portal
          </Link>
          <nav className="portal-nav">
            {navItems.map((item) => (
              <Link
                key={item.to}
                to={item.to}
                className={`portal-nav-link ${location.pathname === item.to ? 'active' : ''}`}
              >
                {item.label}
              </Link>
            ))}
            <Link to="/ip-portal/my-ip" className={`portal-nav-link ${location.pathname === '/ip-portal/my-ip' ? 'active' : ''}`}>
              My IP
            </Link>
            <button onClick={toggleTheme} className="portal-theme-toggle" title={`Switch to ${theme === 'dark' ? 'light' : 'dark'} mode`}>
              {theme === 'dark' ? (
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <circle cx="12" cy="12" r="5" />
                  <path d="M12 1v2M12 21v2M4.22 4.22l1.42 1.42M18.36 18.36l1.42 1.42M1 12h2M21 12h2M4.22 19.78l1.42-1.42M18.36 5.64l1.42-1.42" />
                </svg>
              ) : (
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z" />
                </svg>
              )}
            </button>
            {isAuthenticated && (
              <>
                <span className="portal-admin-name">{admin?.name}</span>
                <button onClick={logout} className="portal-logout-btn">
                  Logout
                </button>
              </>
            )}
          </nav>
        </div>
      </header>
      <main className="portal-main">
        <Outlet />
      </main>
    </div>
  );
};
